import classes from "./styles.module.css";
import DownloadLink from "../../DownloadLink";

interface Props {
  downloadPath: string;
  about: string;
  license: string;
  source: string;
  sourceLink: string;
}

export default function Info({
  downloadPath,
  about,
  license,
  source,
  sourceLink,
}: Props) {
  return (
    <div className={`${classes.container}`}>
      <div className={`${classes.info}`}>
        <h3>About</h3>
        <p>{about}</p>
      </div>

      <div className={`${classes.info}`}>
        <h3>License</h3>
        <p>{license || "License information not available."}</p>
      </div>

      <div className={`${classes.info}`}>
        <h3>Source</h3>
        {sourceLink ? (
          <a
            href={sourceLink}
            target="_blank"
            className={`${classes.sourceLink}`}
          >
            {source}
          </a>
        ) : (
          <p>{source}</p>
        )}
      </div>

      <DownloadLink downloadPath={downloadPath} />
    </div>
  );
}
